import React from 'react';
import ThumbnailImage from '../common/ThumbnailImage';
import { formatShipDate } from '../../utils/formatters';
import './DASHBOARD.css';
import '../product/ProductList.css';

import { ShoppingCart } from 'lucide-react';

// ProductCard 컴포넌트 - ProductList.js와 동일한 스타일 적용
const ProductCard = ({ product, onProductClick, isLoggedIn, showCartButton = false, onCartClick }) => {
    // 할인율 계산
    const calculateDiscount = () => {
        if (!product.disPrice || !product.salePrice || product.salePrice <= product.disPrice) {
            return 0;
        }
        return Math.round(((product.salePrice - product.disPrice) / product.salePrice) * 100);
    };

    const discountPercent = calculateDiscount();

    const handleCardClick = (e) => {
        e.stopPropagation();
        if (onProductClick) {
            onProductClick(product);
        }
    };

    const handleCartButtonClick = (e) => {
        e.stopPropagation();
        if (onCartClick) {
            onCartClick(product);
        }
    };

    // 품절 여부 확인 (예: paramStr2가 'SoldOut'이거나 재고가 0인 경우 등 로직에 따라)
    const isSoldOut = product.paramStr2 === 'SoldOut'; // || product.stockQty <= 0;

    return (
        <div className={`prd_card ${isSoldOut ? 'sold-out' : ''}`} onClick={handleCardClick}>
            {/* 할인 뱃지 표시 */}
            <div className="prd_badge_container">
                {discountPercent > 0 && isLoggedIn && (
                    <span className="prd_discount_badge">
                        {discountPercent}% 할인
                    </span>
                )}
            </div>

            {/* 제품 이미지 */}
            <div className="prd_image_wrapper">
                <ThumbnailImage
                    item={product}
                    src={product.FILEPATH}
                    alt={product.itemNm}
                    className="prd_image"
                    width={200}
                    height={200}
                    useLazy={true} // 초기 로딩 성능 개선을 위해 Lazy Loading 활성화
                    onClick={() => { }} // 클릭 시 내부 모달 열지 않고 상위 이벤트(카드 클릭)로 전파되도록 함
                />

                {/* 품절 오버레이 */}
                {isSoldOut && (
                    <div className="prd_soldout_overlay">
                        <span>SOLD OUT</span>
                    </div>
                )}
            </div>

            {/* 장바구니 버튼 (이미지 바로 하단) */}
            {showCartButton && !isSoldOut && isLoggedIn && (
                <button
                    className="prd_cart_btn_block"
                    onClick={handleCartButtonClick}
                    title="장바구니 담기"
                >
                    <ShoppingCart size={14} />
                    담기
                </button>
            )}

            {/* 제품 정보 */}
            <div className="prd_info">
                {product.itemCd && (
                    <div className="prd_code">{product.itemCd}</div>
                )}

                <h3 className="prd_name">{product.itemNm}</h3>

                <div className="prd_price_container">
                    {product.shipAvDate && (
                        <div className="prd_delivery_badge">
                            {formatShipDate(product.shipAvDate)} 제품등록
                        </div>
                    )}

                    {/* 행사 상품인 경우 재고 수량 표시 (로그인 시에만) */}
                    {isLoggedIn && (product.isEvent || product.stockQty !== undefined) && product.stockQty !== null && product.stockQty !== undefined && (
                        <div className="prd_stock_badge" style={{
                            fontSize: '11px',
                            color: '#ff6b6b',
                            backgroundColor: '#fff0f0',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            marginLeft: '6px',
                            fontWeight: 'bold',
                            border: '1px solid #ffcccc',
                            display: 'inline-block'
                        }}>
                            재고: {Number(product.stockQty).toLocaleString()}개
                        </div>
                    )}

                    {isLoggedIn && (
                        <div className="prd_price_row">
                            {product.disPrice && product.salePrice && product.disPrice !== product.salePrice && product.disPrice > 0 ? (
                                <>
                                    <span className="prd_current_price">
                                        {Number(product.disPrice).toLocaleString()} 원
                                    </span>
                                    <span className="prd_original_price">{Number(product.salePrice).toLocaleString()} 원</span>
                                </>
                            ) : (
                                <span className="prd_current_price">
                                    {Number(product.disPrice || product.salePrice || 0).toLocaleString()} 원
                                </span>
                            )}
                        </div>
                    )}
                </div>

            </div>
        </div>
    );
};

export default ProductCard;
